import React, { useState } from "react";
import { Modal, Box } from "@mui/material";

interface DeleteQnaModalProps {
    visible: boolean;
    onClose: () => void;
    onClickDelete: () => void;
    selectedQnaTitle?: string;
}

const DeleteQnaModal = ({
    visible,
    onClose,
    onClickDelete,
    selectedQnaTitle,
}: DeleteQnaModalProps) => {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <Modal
                open={visible}
                onClose={onClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 bg-white rounded-lg shadow-lg p-6"
                >
                    <h2 id="modal-title" className="text-lg font-bold text-gray-700">
                        Are you sure you want to delete this QnA?
                    </h2>
                    <p id="modal-description" className="mt-2 text-gray-600">
                        {selectedQnaTitle} will be deleted.
                    </p>
                    <button
                        className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        onClick={onClickDelete}
                    >
                        Delete
                    </button>
                    <button
                        className="mt-4 px-4 py-2 bg-gray-300 text-gray-600 rounded hover:bg-gray-400 ml-4"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </Box>
            </Modal>
        </div>
    );
};

export default DeleteQnaModal;
